<template>
    <div>
        <Header/>
        <div class="step">
            <b-container>
                <b-row>
                    <b-col lg="6" class="align-self-center">
                        <b-row class="progress-mobile mb-5 mt-4">
                            <b-row>
                                <b-col cols="1">
                                    <router-link :to="{ name: 'step1'}"> <img src="../assets/img/icn_arrow_back_mobile.svg" alt="arrow icon"></router-link>
                                </b-col>
                                <b-col cols="11">
                                <ProgressBarMobile :percentage="40"/> 
                                </b-col>
                            
                            </b-row>
                        </b-row>
                        <b-row>
                            <b-col lg="12" class="mb-5">
                                <h3>¿DÓNDE VIVES?</h3>
                                <p><strong>PASO 2.</strong> DATOS DE TU DOMICILIO</p>
                            </b-col>
                            <b-form>
                                <b-row>
                                    <b-col lg="12">
                                        <b-form-group
                                            id="input-group-1"
                                            label="Dirección*"
                                            label-for="input-1"
                                            class="mb-4"
                                        >
                                            <b-form-input
                                            id="input-1"
                                            v-model="address"
                                            placeholder="Ingresa tu calle y número"
                                            type="text"
                                            required
                                            :class="{'required':  (btnActive && address=='')}"
                                            ></b-form-input>
                                            <span class="required-label" :class="{'show': (btnActive && address=='')}">Favor de ingresar datos</span>
                                        </b-form-group>
                                    </b-col>

                                    <b-col lg="4">
                                        <b-form-group id="input-group-4" label="Pais*" label-for="input-4" class="mb-4">
                                            <b-form-select 
                                                id="input-4"
                                                v-model="country"
                                                :options="countryOptions"
                                                placeholder="Selecciona un pais"
                                                :class="{'disable': null === country, 'required':  (btnActive && null === country)}"
                                                required
                                            ></b-form-select>
                                        </b-form-group>
                                    </b-col>

                                    <b-col lg="4">
                                        <b-form-group id="input-group-4" label="Estado*" label-for="input-4" class="mb-4">
                                            <b-form-select
                                                id="input-4"
                                                v-if="country == 'Estados Unidos'"
                                                v-model="state"
                                                :options="stateOptionsUS"
                                                placeholder="Selecciona un estado"
                                                :class="{'disable': null === state, 'required':  (btnActive && null === state)}"
                                                required
                                                ></b-form-select>
                                            <b-form-select 
                                                id="input-4"
                                                v-else
                                                v-model="state"
                                                :options="stateOptions"
                                                placeholder="Selecciona un estado"
                                                :class="{'disable': null === state, 'required':  (btnActive && null === state)}"
                                                required
                                                ></b-form-select>
                                            <span class="required-label" :class="{'show': (btnActive && state==null)}">Favor de ingresar datos</span>
                                        </b-form-group>
                                    </b-col>

                                    <b-col lg="4">
                                        <b-form-group
                                            id="input-group-3"
                                            label="Ciudad*"
                                            label-for="input-3"
                                            class="mb-4"
                                        >
                                            <b-form-input
                                            id="input-3"
                                            v-model="city"
                                            type="text"
                                            placeholder="Ingresa tu ciudad" 
                                            :class="{'required':  (btnActive && city=='')}"
                                            required
                                            ></b-form-input>
                                            <span class="required-label" :class="{'show': (btnActive && city=='')}">Favor de ingresar datos</span>
                                        </b-form-group>
                                    </b-col>

                                    <b-col lg="4" v-if="country=='México'">
                                        <b-form-group id="input-group-2" label="Colonia*" label-for="input-2" class="mb-4">
                                            <b-form-input
                                            id="input-2"
                                            v-model="colonia"
                                            placeholder="Ingresa tu colonia"
                                            :class="{'required':  (btnActive && colonia=='')}"
                                            required
                                            ></b-form-input>
                                            <span class="required-label" :class="{'show': (btnActive && colonia=='' && country!='Estados Unidos')}">Favor de ingresar datos</span>
                                        </b-form-group>
                                    </b-col>
                                    
                                    <b-col lg="4">
                                        <b-form-group
                                            id="input-group-5"
                                            label="Código Postal"
                                            label-for="input-5"
                                            class="mb-4"
                                        >
                                            <b-form-input
                                            id="input-5"
                                            v-model="zipcode"
                                            type="text"
                                            placeholder="Ingresa tu C.P."
                                            ></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col lg="4">
                                        <b-form-group id="input-group-6" label="Casa propia" label-for="input-6" class="mb-4">
                                            <b-form-select
                                            id="input-6"
                                            v-model="houseOwnership"
                                            :options="houseOptions"
                                            placeholder="Selecciona una opción"
                                            :class="{'disable': null === houseOwnership}"
                                            ></b-form-select>
                                        </b-form-group>
                                    </b-col>

                                    <b-col lg="4">
                                        <b-form-group
                                            id="input-group-7"
                                            label="Teléfono celular*"
                                            label-for="input-7"
                                            class="mb-4"
                                        >
                                            <b-form-input
                                            v-mask="'(###) ###-####'"
                                            id="input-7"
                                            v-model="cellphone"
                                            type="tel"
                                            placeholder="(___)"
                                            :class="{'required':  (btnActive && cellphone=='')}"
                                            required
                                            ></b-form-input>
                                            <span class="required-label" :class="{'show': (btnActive && cellphone=='')}">Favor de ingresar datos</span>
                                            <span class="required-label" :class="{'show': cellphone.length<14 && cellphone!=''}">El teléfono debe incluir 10 dígitos</span>

                                        </b-form-group>
                                    </b-col>

                                    <b-col lg="5">
                                        <b-form-group
                                            id="input-group-8"
                                            label="Teléfono casa"
                                            label-for="input-8"
                                            class="mb-4"
                                        >
                                            <b-form-input
                                            id="input-8"
                                            v-model="phone"
                                            v-mask="'(###) ###-####'"
                                            type="tel"
                                            placeholder="(___)"
                                            required
                                            ></b-form-input>
                                            <span class="required-label" :class="{'show': phone.length<14 && phone!=''}">El teléfono debe incluir 10 dígitos</span>
                                        </b-form-group>
                                    </b-col>

                                    <b-col lg="7">
                                        <b-form-group
                                            id="input-group-9"
                                            label="Pago mensual (renta o hipoteca)"
                                            label-for="input-9"
                                            class="mb-4 currencyContainer"
                                        >
                                            <b-form-input
                                            id="input-9"
                                            v-model="rent"
                                            v-mask="currencyMask"
                                            type="text"
                                            ></b-form-input>
                                            <span class="money">$</span>
                                            <div class="line"></div>
                                           <b-form-radio-group
                                                id="btn-radios-1"
                                                v-model="currency"
                                                :options="currencyOptions"
                                                :aria-describedby="ariaDescribedby"
                                                name="radios-btn-default"
                                                class="currencyBtn"
                                                buttons
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-4">
                                    <b-col xl="2" lg="3" md="4" class="back-desktop">
                                        <router-link class="btn-back" :to="{ name: 'step1'}"> <img src="../assets/img/icn_arrow_back.svg"  alt="arrow icon"> Regresa</router-link>
                                    </b-col>
                                    <b-col lg="6">
                                        <b-button v-on:click.stop="nextStep"  class="btn-next mb-4">Continuar</b-button>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </b-row>
                    </b-col>
                    <b-col lg="6" class="step-progress-bar">
                        <ProgressBar  :percentage="40" :image="image" />
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import ProgressBar from '../components/ProgressStep.vue'
    import ProgressBarMobile from '../components/ProgressStepMobile.vue'
    import Header from '../components/Header.vue'
    import axios from 'axios'
    import createNumberMask from "text-mask-addons/dist/createNumberMask";
    
    export default {
        data() {
            return {
                btnActive: false,
                image: require('./../assets/img/img_paso2.png'),
                address: '',
                colonia: '',
                city: '',
                country: null,
                state: null,
                zipcode: '',
                cellphone: '',
                phone: '',
                rent: '',
                currencyMask: createNumberMask({
                    prefix: "",
                    includeThousandsSeparator: true,
                    allowNegative: false,
                    thousandsSeparatorSymbol: ",",
                }),
                currency: 'pesos',
                houseOwnership: null,
                houseOptions: [
                    { text: 'Selecciona una opción', value: null, disabled: true }, 
                    { text: 'Casa propia', value: 'propia' }, 
                    { text: 'Rento', value: 'rento' }, 
                    { text: 'Con mis padres', value: 'con mis padres' }
                ],
                currencyOptions: [
                    { text: 'dlls', value: 'dolares' },
                    { text: 'mxn', value: 'pesos' },
                ],
                countryOptions: [
                    { text: 'Selecciona un país', value: null, disabled: true },
                    { text:  'México', value: 'México'},
                    { text:  'Estados Unidos', value: 'Estados Unidos'},
                ],
                stateOptions: [
                    { text: 'Selecciona un estado', value: null, disabled: true }, 
                    { text: 'Aguascalientes ', value: 'Aguascalientes ' }, 
                    { text: 'Baja California', value: 'Baja California' }, 
                    { text: 'Baja California Sur', value: 'Baja California Sur' },
                    { text: 'Campeche', value: 'Campeche' },
                    { text: 'Chiapas', value: 'Chiapas' },
                    { text: 'Chihuahua', value: 'Chihuahua' },
                    { text: 'Ciudad de México', value: 'Ciudad de México' },
                    { text: 'Coahuila', value: 'Coahuila' },
                    { text: 'Colima', value: 'Colima' },
                    { text: 'Durango', value: 'Durango' },
                    { text: 'Estado de México', value: 'Estado de México' },
                    { text: 'Guanajuato', value: 'Guanajuato' },
                    { text: 'Guerrero', value: 'Guerrero' },
                    { text: 'Hidalgo', value: 'Hidalgo' },
                    { text: 'Jalisco', value: 'Jalisco' },
                    { text: 'Michoacán', value: 'Michoacán' },
                    { text: 'Morelos', value: 'Morelos' },
                    { text: 'Nayarit', value: 'Nayarit' },
                    { text: 'Nuevo León', value: 'Nuevo León' },
                    { text: 'Oaxaca', value: 'Oaxaca' },
                    { text: 'Puebla', value: 'Puebla' },
                    { text: 'Querétaro', value: 'Querétaro' },
                    { text: 'Quintana Roo', value: 'Quintana Roo' },
                    { text: 'San Luis Potosí', value: 'San Luis Potosí' },
                    { text: 'Sinaloa', value: 'Sinaloa' },
                    { text: 'Sonora', value: 'Sonora' },
                    { text: 'Tabasco', value: 'Tabasco' },
                    { text: 'Tamaulipas', value: 'Tamaulipas' },
                    { text: 'Tlaxcala', value: 'Tlaxcala' },
                    { text: 'Veracruz', value: 'Veracruz' },
                    { text: 'Yucatán', value: 'Yucatán' },
                    { text: 'Zacatecas', value: 'Zacatecas' },
                ],
                stateOptionsUS: [
                    { text: 'Selecciona un estado', value: null, disabled: true }, 
                    { text: 'Alabama ', value: 'Alabama ' }, 
                    { text: 'Alaska', value: 'Alaska' }, 
                    { text: 'Arizona', value: 'Arizona' },
                    { text: 'Arkansas', value: 'Arkansas' },
                    { text: 'California', value: 'California' },
                    { text: 'Carolina del Norte', value: 'Carolina del Norte' },
                    { text: 'Carolina del Sur', value: 'Carolina del Sur' },
                    { text: 'Colorado', value: 'Colorado' },
                    { text: 'Connecticut', value: 'Connecticut' },
                    { text: 'Dakota del Norte', value: 'Dakota del Norte' },
                    { text: 'Dakota del Sur', value: 'Dakota del Sur' },
                    { text: 'Delaware', value: 'Delaware' },
                    { text: 'Florida', value: 'Florida' },
                    { text: 'Georgia', value: 'Georgia' },
                    { text: 'Hawái', value: 'Hawái' },
                    { text: 'Idaho', value: 'Idaho' },
                    { text: 'Illinois', value: 'Illinois' },
                    { text: 'Indiana', value: 'Indiana' },
                    { text: 'Iowa', value: 'Iowa' },
                    { text: 'Kansas', value: 'Kansas' },
                    { text: 'Kentucky', value: 'Kentucky' },
                    { text: 'Luisiana', value: 'Luisiana' },
                    { text: 'Maine', value: 'Maine' },
                    { text: 'Maryland', value: 'Maryland' },
                    { text: 'Massachusetts', value: 'Massachusetts' },
                    { text: 'Míchigan', value: 'Míchigan' },
                    { text: 'Minnesota', value: 'Minnesota' },
                    { text: 'Misisipi', value: 'Misisipi' },
                    { text: 'Misuri', value: 'Misuri' },
                    { text: 'Montana', value: 'Montana' },
                    { text: 'Nebraska', value: 'Nebraska' },
                    { text: 'Nevada', value: 'Nevada' },
                    { text: 'Nueva Jersey', value: 'Nueva Jersey' },
                    { text: 'Nueva York', value: 'Nueva York' },
                    { text: 'Nuevo Hampshire', value: 'Nuevo Hampshire' },
                    { text: 'Nuevo México', value: 'Nuevo México' },
                    { text: 'Ohio', value: 'Ohio' },
                    { text: 'Oklahoma', value: 'Oklahoma' },
                    { text: 'Oregón', value: 'Oregón' },
                    { text: 'Pensilvania', value: 'Pensilvania' },
                    { text: 'Rhode Island', value: 'Rhode Island' },
                    { text: 'Tennessee', value: 'Tennessee' },
                    { text: 'Texas', value: 'Texas' },
                    { text: 'Utah', value: 'Utah' },
                    { text: 'Vermont', value: 'Vermont' },
                    { text: 'Virginia', value: 'Virginia' },
                    { text: 'Virginia Occidental', value: 'Virginia Occidental' },
                    { text: 'Washington', value: 'Washington' },
                    { text: 'Wisconsin', value: 'Wisconsin' },
                    { text: 'Wyoming', value: 'Wyoming' },
                ],
            }
        },
        components: {
            ProgressBar,
            ProgressBarMobile,
            Header
        },
        methods: {
            checkMask( mask, id ) {
                let el = document.getElementById(id);
                el.setAttribute("v-mask", mask);
            },
            nextStep() {
                let formData = new FormData()
                this.btnActive = true
                var email = sessionStorage.getItem('applicant_email')
                if(this.address && this.city && this.state && this.country && this.cellphone && (this.colonia && this.country=='México' || this.country=='Estados Unidos' )) {
                    formData.append('step', 2)
                    formData.append('applicant_email', email)
                    formData.append('address_street', this.address)
                    formData.append('address_neighbour', this.colonia)
                    formData.append('address_city', this.city)
                    formData.append('address_state', this.state)
                    formData.append('applicant_country', this.country)
                    formData.append('address_zip_code', this.zipcode)
                    formData.append('applicant_phonemobile', this.cellphone)
                    formData.append('applicant_phonehome', this.phone)
                    formData.append('rent', this.rent)
                    formData.append('currency', this.currency)
                    formData.append('home_ownership', this.houseOwnership)
                    axios
                    .post(
                        'https://apply.garlans.com/private/helpers/application_submit_api.php',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        },
                    )
                    .then((response) => {
                        if (!response.data.status) {        
                            this.$router.push('/paso-3')
                        } else {
                            console.log(response)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
                }
            }
        }
    }
</script>

<style scoped>
.step{
    padding: 3% 0;
    text-align: left;
}
h3{
    font-weight: bold;
}
p{
    font-weight: 500;
}
.txt_min{
    width: 50%;
}
label{
    margin-bottom: 10px;
}
.progress-mobile{
    display: none;
}
.custom-select{
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #000;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 0;
}

.disable.custom-select{
  color: rgba(0, 0, 0, 0.3) !important;
}
.custom-select:focus{
    color: #000;
    background-color: #fff;
    border-color: #000;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
}
.form-control {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #000;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 0;
}
.form-control::placeholder{
    color: rgba(0, 0, 0, 0.3);
}
.form-control:focus {
    color: #000;
    background-color: #fff;
    border-color: #000;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
}
.currencyContainer{
    position: relative;
}
.currencyContainer .form-control{
    padding-left:2rem;
    padding-right:3rem;
}
.money{
    position: absolute;
    bottom: 7px;
    left: 10px;
    color: rgba(0, 0, 0, 0.3);
}
.line{
    position: absolute;
    bottom: 7px;
    width: 60%;
    height: 1px;
    left: 30px;
    background: rgba(0, 0, 0, 0.3);
}
.currencyBtn{
    position: absolute;
    right: 10px;
    bottom: 6px;
}
.form-control:focus::placeholder{
    color: transparent;
}
.btn-next,
.btn-next:hover,
.btn-next:focus{
    border-radius: 0;
    color: #fff;
    background: #000;
    width: 100%;
    text-align: center;
    font-weight: bold;
}
.step-progress-bar{
    padding-left: 10%;
    padding-right: 5%;
}
.required-label{
    color: #D85067;
    font-size: 10px;
    position: absolute;
    display: none;
}
.show.required-label{
    display: block;
}
@media (max-width: 1600px) {
    .currencyBtn{
        position: absolute;
        right: 10px;
        bottom: 4px;
    }
    .line{
        width: 60%;
    }
    .currencyContainer .form-control{
        padding-left:2rem;
        padding-right:8rem;
    }
}
@media (max-width: 1399px) {
    .line{
        width: 50%;
    }
}
@media (max-width: 1200px) {
    .line{
        width: 45%;
    }
}
@media (max-width: 991px) {
    .line{
        width: 65%;
    }
}
@media (max-width: 768px) {
    .step{
        padding: 5%;
    }
    .txt_min{
        width: 100%;
    }
    .btn-next,
    .btn-next:hover,
    .btn-next:focus{
        font-size: 15px;
    }
    .back-desktop,
    .step-progress-bar{
        display: none;
    }
    .form-control,
    .custom-select {
        padding: 0.75rem;
    }
    /* .date-picker-input{
        padding-top: 0.3rem !important;
        padding-bottom: 0.3rem !important;
    } */
    .progress-mobile{
        display: block;
    }
    .currencyBtn{
        position: absolute;
        right: 10px;
        bottom: 10px;
    }
    .money{
        bottom: 10px;
    }
    .line{
        width: 50%;
        bottom: 11px;
    }
    .currencyContainer .form-control{
        padding-left:2rem;
        padding-right:8rem;
    }
}

</style>